import { z } from 'zod';

const NewsInterestAreaQuery = z.array(z.object({
    Id: z.number(),
    InterestAreaName: z.string(),
}));

export { NewsInterestAreaQuery };